import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Tree from '../../../../components/Tree'

const styles = theme => ({
    h: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 2,
    },
})

const getPathToRoot = (categoryId, categories, rootId) => {
    const path = []
    let currentId = categoryId

    while (currentId !== rootId && categories[currentId]) {
        path.push(currentId)
        currentId = categories[currentId].parent
    }

    return path
}

const getAllChildren = (categoryId, categories) => {
    const children = []
    const category = categories[categoryId]

    if (!category || !category.children || category.children.length === 0) {
        return children
    }

    category.children.forEach(childId => {
        children.push(childId)
        const grandChildren = getAllChildren(childId, categories)
        children.push(...grandChildren)
    })

    return children
}

const Categories = ({
    updateCategories,
    categories,
    selectedCategories,
    title,
    classes,
}) => {
    const onCheck = categoryId => {
        if (
            selectedCategories
                .map(category => category.categoryId)
                .includes(categoryId)
        ) {
            const childrenIds = getAllChildren(categoryId, categories)
            const toRemove = [categoryId, ...childrenIds]
            const newCategories = selectedCategories.filter(
                category => !toRemove.includes(category.categoryId)
            )
            updateCategories(newCategories)
        } else {
            const categoryExists = Object.prototype.hasOwnProperty.call(
                categories,
                categoryId
            )

            if (categoryExists) {
                const pathIds = getPathToRoot(categoryId, categories, 2)
                const currentIds = selectedCategories.map(c => c.categoryId)
                const newIds = pathIds.filter(id => !currentIds.includes(id))

                const newCategories = [
                    ...selectedCategories,
                    ...newIds.map(id => ({ categoryId: id })),
                ]

                updateCategories(newCategories)
            }
        }
    }

    const selected = selectedCategories.map(({ categoryId }) => categoryId)

    return (
        <div>
            <h3 className={classes.h}>{title}</h3>
            <div>
                <Tree
                    data={categories}
                    selected={selected}
                    onCheck={onCheck}
                    rootId={2}
                    loading={false}
                />
            </div>
        </div>
    )
}

Categories.propTypes = {
    updateCategories: PropTypes.func.isRequired,
    categories: PropTypes.objectOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    selectedCategories: PropTypes.arrayOf(
        PropTypes.shape({
            categoryId: PropTypes.number,
        })
    ).isRequired,
    title: PropTypes.string,
}

Categories.defaultProp = {
    title: 'Lista kategorii',
}

export default withStyles(styles, { withTheme: true })(Categories)
